var _defs, _rect, _path, _path2, _circle, _circle2, _circle3, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 320",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aqChartFill",
    x1: 40,
    y1: 280,
    x2: 440,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3fb9ea",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fb9ea",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 320,
    rx: 28,
    fill: "#f4f7fb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 230 C110 210 140 250 190 180 C240 110 280 160 330 120 C380 80 410 100 432 70 L432 268 L48 268 Z",
    fill: "url(#aqChartFill)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 230 C110 210 140 250 190 180 C240 110 280 160 330 120 C380 80 410 100 432 70",
    stroke: "#3fb9ea",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 180,
    r: 6,
    fill: "#1a9fd4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 120,
    r: 6,
    fill: "#1a9fd4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 70,
    r: 6,
    fill: "#d60000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 48,
    width: 72,
    height: 10,
    rx: 5,
    fill: "#d7e3ee"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 68,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#e6eef5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketChart);
export default __webpack_public_path__ + "static/media/market_chart.0eacb6fc4fa6d0b8215f2e4d2499fbcc.svg";
export { ForwardRef as ReactComponent };